const AssetTypesMapping = Object.freeze({
  0: 'image',
  1: 'video',
  2: 'slide',
  3: 'font',
});


export function isImageAssetType(assetType: any) {
  if (typeof assetType === "string") {
    return assetType === "image";
  } else if (typeof assetType === "number" && assetType in AssetTypesMapping) {
    return AssetTypesMapping[assetType] === "image";
  }
  return false;
}

export default AssetTypesMapping;
